import { gql } from "@apollo/client";

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsReadMutation($id: Int!) {
    markNotificationAsRead(id: $id) {
      ok
      error
    }
  }
`;

export const REMOVE_NOTIFICATION = gql`
  mutation RemoveNotificationMutation($id: Int!) {
    removeNotification(id: $id) {
      ok
      error
    }
  }
`;

export const NOTIFICATIONS = gql`
  query NotificationsQuery($where: NotificationsFiltersInput!) {
    notifications(where: $where) {
      ok
      error
      total
      results {
        id
        title
        content
        table
        objectId
        isRead
        createdAt
      }
    }
  }
`;
